<template>
  <section section class="section-block">
    <SectionTitle title="預約扣堂票設定" @edit="modal.edit = true" />
    <BaseElForm label-position="left" label-width="250px">
      <BaseElFormItem label="是否開啟預約扣堂票">
        {{ displayData.enabled }}
      </BaseElFormItem>
    </BaseElForm>

    <EditReservationClassTicketSetting
      v-if="modal.edit"
      :configData="configData"
      @close="modal.edit = false"
      @refresh="$emit('refresh')"
    />
  </section>
</template>

<script>
import { get } from 'lodash'
import { computed, defineComponent, reactive } from 'vue'
import SectionTitle from '@/components/Title/SectionTitle.vue'
import EditReservationClassTicketSetting from './EditReservationClassTicketSetting.vue'

export default defineComponent({
  name: 'ReservationClassTicketSetting',
  components: { SectionTitle, EditReservationClassTicketSetting },
  props: {
    configData: { type: Object, default: () => ({}) },
  },
  emits: ['input'],
  setup (props, { emit }) {
    const modal = reactive({
      edit: false,
    })
    const displayData = computed(() => {
      return {
        enabled: get(props.configData, 'enableClassTicket') ? '開啟' : '關閉',
      }
    })

    return {
      modal,
      displayData,
    }
  },
})
</script>

<style scoped lang="postcss">
.setting-row {
  @apply flex items-center;
}
.setting-label {
  @apply mr-4 text-base;
}
</style>
